import {Component, OnDestroy, OnInit} from '@angular/core';
import {LotteriesService} from '../lotteries.service';
import * as globals from '../settings';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import {SeoService} from '../_services/seo.service';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {LogoutService} from '../_services/logout.service';
import {HttpClient} from '@angular/common/http';
import {JsontranslateService} from '../_services/jsontranslate.service';
import {CounterService} from '../_services/counter.service';
import {Subscription} from 'rxjs';
import {CurrencyService} from '../_services/currency.service';
import {JackpotConfigService} from '../_services/jackpotConfig.service';

@Component({
  selector: 'app-latest-lotteries-result',
  templateUrl: './latest-lotteries-result.component.html',
  styleUrls: ['./latest-lotteries-result.component.scss']
})
export class LatestLotteriesResultComponent implements OnInit, OnDestroy {
  pageTitle: string;
  pageDescription: string;
  lotteries: any;
  user: any;
  languageChange: any;
  showLang: any;
  showLangRoute: any;
  route: any;
  changedCurrency: Subscription;
  currency: any;
  brand = globals.brand;
  constructor(public lotteryService: LotteriesService,
              public subscriptionsService: SubscriptionsService,
              private translate: TranslateService,
              private logoutService: LogoutService,
              private seo: SeoService,
              private http: HttpClient,
              private jsontranslate: JsontranslateService,
              public counterService: CounterService,
              public currencyService: CurrencyService,
              public jackpotConfig: JackpotConfigService) {
    this.currency = this.currencyService.currency;
    this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
      if (currency) {
        this.currency = currency;
      }
    });
    this.showLang = localStorage.getItem('pageLanguage');
  }

  ngOnInit() {
    this.logoutService.loggedInCheck();
    this.setMetaTags();

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.setMetaTags();
      this.jsontranslate.loadTranslations('LotteriesResultComponent', this.translate.currentLang);
    });

    window.scrollTo(0, 0);
    const userDataString = localStorage.getItem('playerDetails');
    const userDataJson = JSON.parse(userDataString);
    this.user = userDataJson;
    this.lotteryService.getLotteries
    (globals.appDomain + '/draws/lastLotteryResult/drawsLastLotteryResult.html')
      .subscribe(
        result => {
          this.lotteries = result;
          this.lotteries.forEach ( (object) => {
            object.upcoming.jackpotAmount = object.upcoming.jackpotAsStringRounded[0];
            object.upcoming.jackpotAmountDE = object.upcoming.jackpotAsStringRoundedDE[0];
            object.upcoming.jackpotString = object.upcoming.jackpotAsStringRounded[1];
            object.upcoming.jackpotStringDE = object.upcoming.jackpotAsStringRoundedDE[1];
          });
        }
      );

  }

  ngOnDestroy() {
    if (this.languageChange) {
      this.languageChange.unsubscribe();
    }
    if (this.changedCurrency) {
      this.changedCurrency.unsubscribe();
    }
  }

  setMetaTags() {
    if (this.translate.currentLang === 'de') {
      this.seo.setTitle('Internationale Lotto Ergebnisse | STG Demo Lotto');
      this.seo.setDescription('Finde die Gewinnzahlen und Jackpots für die größten Lotterien der Welt heraus!');
    } else {
      this.seo.setTitle('International Lottery Results | STG Demo Lotto');
      this.seo.setDescription('Get the latest winning numbers for the world’s leading lotteries');
    }
  }

  formatDate(obj) {
    return (new Date(obj)).toISOString().split('T')[0].replace(/-/g, ' - ');
  }

}
